var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.764923,
    y: 49.8824,
    width: 50,
    height: 50,
    transform: "rotate(-79.2192 0.764923 49.8824)",
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7818,
    y: 48.8025,
    width: 37,
    height: 35,
    transform: "rotate(-89.3386 12.7818 48.8025)",
    fill: "url(#pattern1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_106_9",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_106_9",
    transform: "translate(0.027027) scale(0.0189189 0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_106_9",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABu0lEQVR4nO2azUrDQBCAc7faiH/vpVaEgndFX0KN+BiiUCx9iGoPVWrr2b5A0Zv1bj8ZmEORHjbNZjPGfJBLugS+ZDIzO2kUVVRUBAPYBhpAAnSAR2Cox4OeS3TNVmQJYB04AwbADHdk7TNwCsRFC1wDX2RnClwFFwKOgA/88w40QwisAi3y5w6o5SWxA4wIx1CSRx4SY8Iz9iaj4fRKcQy9hJnGa9Hc+8hOVmhmqRN5pNgsqTleRkSKnTWSZZ6GVFtrfKZ6Kto7WeUkjYg0gFZ5StOKp+liQzMDNl1EDrDPvouIbHysc+4iIrs467RdRHrYp+siUmSD6MroX4n0KElodSjJy55QkvTbwD57ZWhRvp1aFJWRCaBV+k4SKiJjTKscpxGJDW+s6s4iKiOzWGtcppJQkTVgwl8fPggygsEOh1EWgNuiDYBWJgkVqenYsigGwEpmkbkiWcQQ+837JzpgQyYYASVevH9W+BVmIYbaN97CySGbSTr0zSRzdlpCJtaWf+qpYl+krtqeheoyxtT3RzpTV2RtX3qnQgUWIe217BX07rZlSzr3h4GunpPfdiV5LLxIRUVFlAc/ckQQyBID3V0AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_106_9",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABS0lEQVR4nO2ZvU7DQAzHj248CKLFDjNPwAMwVAgkPhZGts50pHY6M6E+RCUWHocBJCaIXSEgOtShoh2gUnRpkot/kocsd/rLH2fHzhmGYUQHgwwY9LEak0FAITphVF+JgU5MyBqPTNNEr8o0Rp2W7xHQYbCD/75vaEL+wzxSELbQqltooV5Hkeze+S0CuWukEAY9Ypz1F983zncY9L5RQuYiCOSTQb4YZsfLYgjksBFCxgd+m0GeFucTyDcl2Ykrg7I9Mkredhn1eUUMyFnoezaSIym+dwn0ZVkM78l50Es2VbUIs31Cff1tUCWnRC4qEzLqfewQ6G1Be1idSSRnlMtKhMwrTdgBS/IUs1MT4toeWiGTnUNWLiu/bXoQxzG1KBxD0xhVGx/VYBXlqMv2F2UN5pGCsIVWK9cKaBsrX4PVm8SxDDUMw3B14QdUI5cXqXvKeAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.6c4d7a211c2ff5720f97fd598b410b79.svg";
export { ForwardRef as ReactComponent };